import { call, put, takeEvery } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import UpdateLoanLiabilities from "Communication/ApiClasses/UpdateLoanLiabilitiesRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleUpdateLoanLiabilities(action) {
  yield put(
    doLoadingStart(STRINGS.LIABILITIES.API_KEYS.LOAN_UPDATE_LIABILITIES)
  );
  const updateLoanLiabilities = new UpdateLoanLiabilities(
    action.data.applicantId,
    action.data.finAnalysisId,
    action.data.financialId,
    action.data.payLoad
  );
  try {
    const result = yield call(updateLoanLiabilities.getData);
    yield put({
      type: actionTypes.LOAN_UPDATE_LIABILITIES_SUCCESS,
      response: result,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.LOAN_UPDATE_LIABILITIES_ERROR,
      error: e.message,
    });
  } finally {
    yield put(
      doLoadingFinish(STRINGS.LIABILITIES.API_KEYS.LOAN_UPDATE_LIABILITIES)
    );
  }
}

// watcher
function* updateLoanLiabilitiesWatcherSaga() {
  yield takeEvery(
    actionTypes.LOAN_UPDATE_LIABILITIES,
    handleUpdateLoanLiabilities
  );
}

export default updateLoanLiabilitiesWatcherSaga;
